import { Tooltip } from '@interstate/components/Tooltip';
import { InformationCircleIcon } from '@interstate/components/Icons';
import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';
import * as consumerInsightsSelectors from '@makemydeal/dr-dash-store/selectors/consumerInsightsSelectors';
import { useSelector } from 'react-redux';
import { camelCase } from 'lodash';
import { formatDollarsAndCents } from '@makemydeal/dr-common-utils';
import { ADJUSTABLE_FIELDS } from './constants/adjustableFields';

export interface IToolTipRenderingProps {
    toolTipContentPlaceHolder: string;
}

const DealPulseToolTipRenderer = ({ toolTipContentPlaceHolder }: IToolTipRenderingProps) => {
    const theme = useInterstateTheme();
    const dealPulseData = useSelector(consumerInsightsSelectors.getConsumerInsights);
    const validToolTipContentPlaceHolders = ['Down Payment', 'Payment'];
    const { preferredDownHigh, preferredDownLow, preferredMonthlyHigh, preferredMonthlyLow } = dealPulseData || {};

    if (Object.keys(dealPulseData || {}).length === 0 || !validToolTipContentPlaceHolders.includes(toolTipContentPlaceHolder)) {
        return;
    }

    const paymentRangeStart =
        toolTipContentPlaceHolder === ADJUSTABLE_FIELDS.DOWN_PAYMENT
            ? formatDollarsAndCents(preferredDownLow)
            : formatDollarsAndCents(preferredMonthlyLow);
    const paymentRangeEnd =
        toolTipContentPlaceHolder === ADJUSTABLE_FIELDS.DOWN_PAYMENT
            ? formatDollarsAndCents(preferredDownHigh)
            : formatDollarsAndCents(preferredMonthlyHigh);

    const toolTipContent = !(paymentRangeStart.includes('--') || paymentRangeEnd.includes('--'))
        ? `Deal Pulse ${toolTipContentPlaceHolder} Range: ${paymentRangeStart} - ${paymentRangeEnd}`
        : null;

    return toolTipContent ? (
        <Tooltip
            id="tooltipLink"
            toolTipContent={toolTipContent}
            data-testid={`deal-pulse-${camelCase(toolTipContentPlaceHolder)}-tooltip-icon`}
            size="large"
            position="top-start"
        >
            <InformationCircleIcon
                data-testid={`target-${camelCase(toolTipContentPlaceHolder)}-info-icon`}
                color={theme.tokens.BaseColorBlue500}
            />
        </Tooltip>
    ) : null;
};

export default DealPulseToolTipRenderer;
